import { createAction } from '@reduxjs/toolkit';

export const openConversationScreen = createAction<{
    channelSid: string | undefined;
}>('OPEN_CONVERSATION_SCREEN');

export type OpenConversationScreen = ReturnType<typeof openConversationScreen>;

export const logout = createAction('LOGOUT');
